function getToggleStrings() {
  return window.translations || {
    showMore: "Show More",
    showLess: "Show Less",
  };
}

function toggleTextDesc() {
  let e = document.getElementById("descriptionTextDesc"),
  t = document.getElementById("showMoreBtnDesc");
  strings = getToggleStrings();
  if (e.classList.contains("expanded")) {
    let n = parseFloat(window.getComputedStyle(e).lineHeight);
    (e.style.maxHeight = `${6 * n}px`),
      e.classList.remove("expanded"),
      (t.textContent = strings.showMore);
  } else
    e.classList.add("expanded"),
      (e.style.maxHeight = "100%"),
      (t.textContent = strings.showLess);
}
function toggleText() {
  let e = document.getElementById("descriptionText"),
    t = document.getElementById("showMoreBtn");
  if (e.classList.contains("expanded")) {
    let n = parseFloat(window.getComputedStyle(e).lineHeight);
    (e.style.maxHeight = `${6 * n}px`),
      e.classList.remove("expanded"),
      (t.textContent = strings.showMore);
  } else
    e.classList.add("expanded"),
      (e.style.maxHeight = "100%"),
      (t.textContent = strings.showLess);
}
function checkTextOverflow(elementId, buttonId) {
  let e = document.getElementById(elementId),
    t = document.getElementById(buttonId);
  if (!e) {
    return;
  }

  if (!t) {
    return;
  }
  let lineHeight = parseFloat(window.getComputedStyle(e).lineHeight);
  let maxHeight = 6 * lineHeight;

  e.style.maxHeight = `${maxHeight}px`;

  if (e.scrollHeight <= maxHeight) {
    t.style.display = "none";
  }
}
document.addEventListener("DOMContentLoaded", () => {
  let e = document.querySelectorAll(".faq-toggle");
  e.forEach((e) => {
    e.addEventListener("click", () => {
      let t = e.closest(".grid__single-product-faq-qa");
      document
        .querySelectorAll(".grid__single-product-faq-qa.active")
        .forEach((e) => {
          e !== t && e.classList.remove("active");
        }),
        t.classList.toggle("active");
    });
  });
}),
  document.addEventListener("DOMContentLoaded", function () {
    checkTextOverflow("descriptionTextDesc", "showMoreBtnDesc");
    checkTextOverflow("descriptionText", "showMoreBtn");
  }),
  document.addEventListener("DOMContentLoaded", function () {
    const descriptionTextDesc = document.getElementById("descriptionTextDesc");
    const showMoreBtnDesc = document.getElementById("showMoreBtnDesc");

    if (descriptionTextDesc && showMoreBtnDesc) {
      const lineHeight = parseFloat(
        window.getComputedStyle(descriptionTextDesc).lineHeight
      );
      const maxHeight = 6 * lineHeight;

      if (descriptionTextDesc.scrollHeight > maxHeight) {
        descriptionTextDesc.style.maxHeight = `${maxHeight}px`;
        descriptionTextDesc.classList.add("text-container");
        showMoreBtnDesc.style.display = "inline";
      }
    }
    const scrollToDescriptionBtn = document.getElementById(
      "scrollToDescription"
    );
    const descriptionSection = document.getElementById("description-section");

    if (scrollToDescriptionBtn && descriptionSection) {
      $("#scrollToDescription").on("click", function (e) {
        e.preventDefault();
        const offsetTop =
          descriptionSection.offsetTop + descriptionSection.offsetHeight;
        $("html, body").animate({ scrollTop: offsetTop }, 1000);
      });
    }

    const toAnimateElements = document.querySelectorAll(".to-animate");

    if (toAnimateElements.length > 0) {
      function handleScroll() {
        const windowHeight = window.innerHeight;
        toAnimateElements.forEach((el) => {
          const rectTop = el.getBoundingClientRect().top;
          if (rectTop < windowHeight && rectTop > 0) {
            el.classList.add("visible");
          }
        });
      }

      window.addEventListener("scroll", handleScroll);
      handleScroll();
    }
  }),
  document.addEventListener("DOMContentLoaded", function () {
    const descriptionText = document.getElementById("descriptionText");
    const showMoreBtn = document.getElementById("showMoreBtn");

    if (descriptionText && showMoreBtn) {
      try {
        const lineHeight = parseFloat(
          window.getComputedStyle(descriptionText).lineHeight
        );
        const maxHeight = 6 * lineHeight;

        if (descriptionText.scrollHeight > maxHeight) {
          descriptionText.style.maxHeight = `${maxHeight}px`;
          descriptionText.classList.add("text-container");
          showMoreBtn.style.display = "inline";
        }
      } catch (error) { }
    }
  }),
  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (e) {
      if (
        location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var t = $(this.hash);
        (t = t.length ? t : $("[name=" + this.hash.slice(1) + "]")).length &&
          (e.preventDefault(),
            $("html, body").animate(
              { scrollTop: t.offset().top - 100 },
              1e3,
              function () {
                var e = $(t);
                if ((e.focus(), e.is(":focus"))) return !1;
                e.attr("tabindex", "-1"), e.focus();
              }
            ));
      }
    });
